<template>
	<view class="box">
		<view class="box_content">
			<view class="label">使用凭证</view>
			<view class="content">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<text class="content_a">券号：380848938403284</text>
				<text class="content_b">有效期至 2023-05-11 23:59</text>
			</view>
		</view>
		<view class="box_store">
			<view class="box_store_label">适用门店</view>
			<view class="box_store_info">
				<image src="@/static/uni.png" mode="widthFix"></image>
				<view class="info_right">
					<text>瑞辛咖啡（虹桥协信中心店）</text>
					<text>虹桥枢纽</text>
				</view>
			</view>
			<view class="box_store_x"></view>
			<view class="box_store_bottom">
				<text>上海市闵行区沈虹路671号虹桥协信办</text>
				<view class="box_store_bottom_right">
					<text>导航</text>
					<uni-icons type="forward" size="15" color="#999999"></uni-icons>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_content {
			width: 100%;
			box-sizing: border-box;
			padding: 28rpx 32rpx;
			background-color: #ffffff;
			.label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.content {
				margin-top: 36rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				image {
					width: 296rpx;
					height: 296rpx;
				}
				.content_a {
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
					margin-top: 36rpx;
				}
				.content_b {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					margin-top: 16rpx;
				}
			}
		}
		.box_store {
			width: 100%;
			margin-top: 16rpx;
			background-color: #ffffff;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			.box_store_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.box_store_info {
				margin-top: 24rpx;
				display: flex;
				align-items: center;
				image {
					flex-shrink: 0;
					width: 92rpx;
					height: 92rpx;
					margin-right: 18rpx;
				}
				.info_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					text {
						&:nth-child(1) {
							font-size: 32rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
						&:nth-child(2) {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
							margin-top: 16rpx;
						}
					}
				}
			}
			.box_store_x {
				width: 100%;
				height: 2rpx;
				background-color: #F4F5F4;
				margin: 20rpx 0;
			}
			.box_store_bottom {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
				}
				.box_store_bottom_right {
					display: flex;
					align-items: center;
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						margin-right: 8rpx;
					}
				}
			}
		}
	}
</style>